module.exports = __webpack_public_path__ + "img/gallery20-1.23a90b6c.jpg";